import { __extends } from "tslib";
import { Event } from './Event';
import { EventDispatcherBase } from './EventDispatcherBase';
import { release } from '@awayfl/swf-loader';
import { assert } from '@awayjs/graphics';
import { MouseEvent } from '../events/MouseEvent';
/**
     * [broadcast event] Dispatched when the Flash Player or AIR application operating
     * loses system focus and is becoming inactive.
     * @eventType	flash.events.Event.DEACTIVATE
    [Event(name="deactivate", type="flash.events.Event")]

     * [broadcast event] Dispatched when the Flash Player or AIR application gains
     * operating system focus and becomes active.
     * @eventType	flash.events.Event.ACTIVATE
    [Event(name="activate", type="flash.events.Event")]
 */
var EventDispatcher = /** @class */ (function (_super) {
    __extends(EventDispatcher, _super);
    function EventDispatcher(target) {
        if (target === void 0) { target = null; }
        var _this = _super.call(this, target) || this;
        _this.eventMapping = {};
        _this.eventMappingDummys = {};
        _this.eventMappingExtern = {};
        _this.eventMappingInvert = {}; //only needed in some cases, when we translate back from awayjs-type to flash-type
        _this._activateCallbackDelegate = function (event) { return _this.activateCallback(event); };
        _this.eventMapping[Event.ACTIVATE] = {
            adaptedType: '',
            addListener: _this.initActivateListener,
            removeListener: _this.removeActivateListener,
            callback: _this._activateCallbackDelegate
        };
        _this._deactivateCallbackDelegate = function (event) { return _this.deactivateCallback(event); };
        _this.eventMapping[Event.DEACTIVATE] = {
            adaptedType: '',
            addListener: _this.initDeactivateListener,
            removeListener: _this.removeDeactivateListener,
            callback: _this._deactivateCallbackDelegate
        };
        return _this;
    }
    EventDispatcher.prototype.toString = function () {
        return '';
    };
    EventDispatcher.prototype.hasEventListener = function (type, listener) {
        return _super.prototype.hasEventListener.call(this, type, listener);
    };
    EventDispatcher.prototype.willTrigger = function () {
    };
    EventDispatcher.prototype.dispatchEvent = function (event, comesFromAway) {
        if (comesFromAway === void 0) { comesFromAway = false; }
        event.currentTarget = this;
        if (event.type == 'enterFrame') { //} || event.type=="scroll"){
            event.target = this;
        }
        var returnVal = _super.prototype.dispatchEvent.call(this, event);
        // workaround for now.
        // mousevents already bubble up the scenegraph in MouseMangager
        // for all other events, we want to bubble them up here:
        if (!comesFromAway && EventDispatcher.eventsThatBubbleInAwayJS.indexOf(event.type) == -1) {
            if (this.adaptee && this.adaptee.parent) {
                this.adaptee.parent.adapter.dispatchEvent(event);
            }
        }
        return returnVal;
    };
    // ---------- event mapping functions Event.ACTIVATE
    EventDispatcher.prototype.initActivateListener = function (type, callback) {
        window.onfocus = callback;
    };
    EventDispatcher.prototype.removeActivateListener = function (type, callback) {
        window.onfocus = null;
    };
    EventDispatcher.prototype.activateCallback = function (event) {
        if (event === void 0) { event = null; }
        this.dispatchEvent(new this.sec.flash.events.Event(Event.ACTIVATE));
    };
    // ---------- event mapping functions Event.DEACTIVATE
    EventDispatcher.prototype.initDeactivateListener = function (type, callback) {
        window.onblur = callback;
    };
    EventDispatcher.prototype.removeDeactivateListener = function (type, callback) {
        window.onblur = null;
    };
    EventDispatcher.prototype.deactivateCallback = function (event) {
        if (event === void 0) { event = null; }
        this.dispatchEvent(new this.sec.flash.events.Event(Event.DEACTIVATE));
    };
    /*overwrite*/
    EventDispatcher.prototype.addEventListener = function (type, listener, useCapture, priority, useWeakReference) {
        if (useCapture === void 0) { useCapture = false; }
        if (priority === void 0) { priority = 0; }
        if (useWeakReference === void 0) { useWeakReference = false; }
        if (!useCapture && Event.isBroadcastEventType(type)) {
            BroadcastEventDispatchQueue.getInstance().add(type, this);
        }
        if (!this.eventMappingDummys) {
            //throw("called addEventListener for object that wasnt init yet");
            return;
        }
        if (this.eventMappingDummys.hasOwnProperty(type)) {
            // this is a dummy eventMapping
            // this means that this is a event-type, that is not yet supported
            // we do not need to register it on superclass
            // for now we output a warning
            //console.log("Warning - EventDispatcher:  trying to listen for unsupported event: : "+this.eventMappingDummys[type]);
            return;
        }
        else if (this.eventMapping.hasOwnProperty(type)) {
            // a mapping exists for this event
            //making sure standart behaviour still works (listener is tracked in list)
            _super.prototype.addEventListener.call(this, type, listener, useCapture, priority, useWeakReference);
            // call the provided "addListener" function
            this.eventMapping[type].addListener.call(this, this.eventMapping[type].adaptedType, this.eventMapping[type].callback, listener);
            return;
        }
        //if(this.eventMappingExtern.hasOwnProperty(type)){
        else {
            // this is a external eventMapping
            // this means that we do not need to create any mapping, and will manually dispatch the event
            // we still need to register it on superclass, so it will work if we dispatch it manually
            _super.prototype.addEventListener.call(this, type, listener, useCapture, priority, useWeakReference);
            return;
        }
        // if we make it here, the event is not handled by this dispatcher
        // lets output a Warning for now.
        //console.log("EventDispatcher: trying to listen for unknown event: '"+type+"'")
    };
    /**
     * Remove an event listener
     * @method removeEventListener
     * @param {String} type of event to remove a listener for
     * @param {Function} listener function
     */
    EventDispatcher.prototype.removeEventListener = function (type, listener) {
        if (!this.eventMappingDummys) {
            console.log('todo: remove queued addEventListener');
            return;
        }
        _super.prototype.removeEventListener.call(this, type, listener);
        if (this.eventMapping.hasOwnProperty(type)) {
            // a mapping exists
            this.eventMapping[type].removeListener.call(this, this.eventMapping[type].adaptedType, this.eventMapping[type].callback, listener);
            if (!this.hasEventListener(type)) {
                if (Event.isBroadcastEventType(type)) {
                    BroadcastEventDispatchQueue.getInstance().remove(type, this);
                }
            }
        }
    };
    EventDispatcher.eventsThatBubbleInAwayJS = [
        MouseEvent.MOUSE_WHEEL,
        MouseEvent.MOUSE_UP,
        MouseEvent.MOUSE_OVER,
        MouseEvent.MOUSE_OUT,
        MouseEvent.ROLL_OVER,
        MouseEvent.ROLL_OUT,
        MouseEvent.MOUSE_MOVE,
        MouseEvent.MOUSE_DOWN,
        MouseEvent.DOUBLE_CLICK,
        MouseEvent.CLICK,
        Event.ENTER_FRAME,
        Event.EXIT_FRAME,
        Event.FRAME_CONSTRUCTED,
        Event.ADDED_TO_STAGE,
        Event.RESIZE,
        Event.REMOVED_FROM_STAGE,
    ];
    return EventDispatcher;
}(EventDispatcherBase));
export { EventDispatcher };
var BroadcastEventDispatchQueue = /** @class */ (function () {
    function BroadcastEventDispatchQueue() {
        this.reset();
    }
    BroadcastEventDispatchQueue.getInstance = function () {
        if (!BroadcastEventDispatchQueue._instance)
            BroadcastEventDispatchQueue._instance = new BroadcastEventDispatchQueue();
        return BroadcastEventDispatchQueue._instance;
    };
    BroadcastEventDispatchQueue.prototype.reset = function () {
        this._queues = {};
    };
    BroadcastEventDispatchQueue.prototype.add = function (type, target) {
        // release || assert(Event.isBroadcastEventType(type), "Can only register broadcast events.");
        var queue = this._queues[type] || (this._queues[type] = []);
        if (queue.indexOf(target) >= 0) {
            return;
        }
        queue.push(target);
    };
    BroadcastEventDispatchQueue.prototype.remove = function (type, target) {
        //release || assert (Event.isBroadcastEventType(type), "Can only unregister broadcast events.");
        var queue = this._queues[type];
        release || assert(queue, 'There should already be a queue for this.');
        var index = queue.indexOf(target);
        release || assert(index >= 0, 'Target should be somewhere in this queue.');
        queue[index] = null;
        release || assert(queue.indexOf(target) < 0, 'Target shouldn\'t be in this queue anymore.');
    };
    BroadcastEventDispatchQueue.prototype.dispatchEvent = function (event) {
        //release || assert (event.isBroadcastEvent(), "Cannot dispatch non-broadcast events.");
        var queue = this._queues[event._type];
        if (!queue) {
            return;
        }
        /*
        if (!release && traceEventsOption.value) {
          console.log('Broadcast event of type ' + event._type + ' to ' + queue.length +
                      ' listeners');
        }*/
        var nullCount = 0;
        for (var i = 0; i < queue.length; i++) {
            var target = queue[i];
            if (target === null) {
                nullCount++;
            }
            else {
                target.dispatchEvent(event);
            }
        }
        // Compact the queue if there are too many holes in it.
        if (nullCount > 16 && nullCount > (queue.length >> 1)) {
            var compactedQueue = [];
            for (var i = 0; i < queue.length; i++) {
                if (queue[i]) {
                    compactedQueue.push(queue[i]);
                }
            }
            this._queues[event.type] = compactedQueue;
        }
    };
    BroadcastEventDispatchQueue.prototype.getQueueLength = function (type) {
        return this._queues[type] ? this._queues[type].length : 0;
    };
    return BroadcastEventDispatchQueue;
}());
export { BroadcastEventDispatchQueue };
